<genealogy-chart
    [genealogies]="genealogies"
    [genealogyChartConfig]="genealogyChartConfig"
    [selectedSubscriptionName]="selectedSubscriptionName"
></genealogy-chart>
